import { BeautyService } from './types';

export const fragranceBeautyServices: BeautyService[] = [
  {
    title: "DISCOVER YOUR SIGNATURE",
    description:
      "An exclusive, sensory experience to find the Christian Louboutin fragrance that best suits you.",
    imagePath: "/looks-gallery/beauty-services/5.jpg",
    duration: 15,
  },
  {
    title: "DISCOVER YOUR ALLURE",
    description:
      "Step into the world of Louboutin — reveal your ultimate allure through a digitally immersive, tailor-made questionnaire.",
    imagePath: "/looks-gallery/beauty-services/6.png",
    duration: 15,
  },
]; 